import _ from 'lodash';
import { Text } from 'common-components/typography';
import React from 'react';

import { EndSpacer } from '../roster-daily/components/EndSpacer';
import { rosterConfig } from '../roster-config';

const { TIMELINE_HOUR_BLOCK_WIDTH, TIMELINE_HOUR_BLOCK_HEIGHT } = rosterConfig;

interface HourBlockProps {
  hour: string;
  first?: boolean;
}

function HourBlock({ hour, first }: HourBlockProps) {
  return (
    <div
      className={`line-height-100 bordered-bottom text-align-center select-none flex-row align-center justify-center roster-gray ${first ? '' : 'bordered-left'}`}
      style={{
        minWidth: `${TIMELINE_HOUR_BLOCK_WIDTH}px`,
        maxWidth: `${TIMELINE_HOUR_BLOCK_WIDTH}px`,
        height: TIMELINE_HOUR_BLOCK_HEIGHT,
      }}
    >
      <Text lineHeight={100} size='regular' color='secondary'>
        {hour}
      </Text>
    </div>
  );
}

interface HoursDisplayProps {
  hours: string[];
}

export function HoursDisplay({ hours }: HoursDisplayProps) {
  return (
    <div>
      <div className='flex-row roster-gray'>
        {_.map(hours, (hour, idx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <HourBlock key={idx} hour={hour} first={idx === 0} />
        ))}
        <EndSpacer height={TIMELINE_HOUR_BLOCK_HEIGHT} />
      </div>
    </div>
  );
}
